import * as actionTypes from '../constants';

const initialState = {
	data: [],
	loading: false,
};

export default function applicationRdx(state = initialState, action) {
	switch (action.type) {
		case actionTypes.LOADED_APPLICATION:
			return {
				...state,
				loading: action.loading,
				data:{...action.application}
			};
		case actionTypes.LOADING_APPLICATION:
		return {
				...state,
				loading: action.loading,
			};
		default:
			return state;
	}
}
